import React from 'react';
import SelectField from '../../forms/SelectField';
import Checkbox from '../../forms/Checkbox';

const CopyFromPartnerFields = ({
    selectLabel,
    selectName,
    selectItems,
    selectValue,
    onSelectChange,
    copyClearances,
    copyVisibleCategories,
    onCopyClearancesChange,
    onCopyVisibleCategoriesChange,
    showCheckboxes = true,
    showValidationError = false,
    displayEmpty
}) => (
    <React.Fragment>
        <div className="ckp-admin-grid-row" style={{ alignItems: 'center', gap: '40px' }}>
            <SelectField
                label={selectLabel}
                onChange={onSelectChange}
                name={selectName}
                items={selectItems}
                value={selectValue}
                displayEmpty={displayEmpty}
            />
            {showCheckboxes && (
                <div className="ckp-admin-grid-row u-margin-bottom-2" style={{ gap: '12px' }}>
                    <Checkbox
                        name="copy-clearances"
                        label="Copy Clearances"
                        checked={copyClearances}
                        onChange={onCopyClearancesChange}
                    />
                    <Checkbox
                        name="copy-visible-categories"
                        label="Copy Visible Categories"
                        checked={copyVisibleCategories}
                        onChange={onCopyVisibleCategoriesChange}
                    />
                </div>
            )}
        </div>
        {showValidationError && (
            <p className="u-margin-top-2" style={{ color: '#d32f2f', fontSize: '0.9em' }}>
                Please select at least one option to copy.
            </p>
        )}
    </React.Fragment>
);

export default CopyFromPartnerFields;
